module.exports = __webpack_public_path__ + "img/project10_9.jpg.c0793233.webp";